module.exports = __webpack_public_path__ + "static/media/superman.9e643759.png";